import { SelectItem, SelectItemWithLabel } from 'components//select/types';

const selectPredicate =
    <T>(value: SelectItem<T>) =>
    (item: SelectItem<T>) => {
        if (typeof value === 'string') {
            return value === (item as string);
        }

        return value.id === (item as SelectItemWithLabel<T>).id;
    };

export { selectPredicate };
